import { render } from "./RecargaConsultasView.vue?vue&type=template&id=b511de9a&scoped=true"
import script from "./RecargaConsultasView.vue?vue&type=script&lang=js"
export * from "./RecargaConsultasView.vue?vue&type=script&lang=js"

import "./RecargaConsultasView.vue?vue&type=style&index=0&id=b511de9a&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b511de9a"]])

export default __exports__